import useActivityTimeline from "@/modules/lead-page/new/hooks/activity-timline.hook";
import { format, parseISO } from "date-fns";

const LastActivityDate = () => {
  const { mostRecentActivityItem } = useActivityTimeline();

  if (!mostRecentActivityItem) return "No updates yet";

  return `Last updated at ${format(
    parseISO(mostRecentActivityItem.createdAt),
    "d MMM yyyy, h:mm a"
  )}`;
};

export default LastActivityDate;
